import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StpRegistrationStorageService } from '../../services/stp-registration-storage.service';
import { StpRegistrationService } from '../../services/stp-registration.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginResponse } from 'src/app/modules/authentication/models/login-response.dto';

@Component({
  selector: 'app-stp-tab',
  templateUrl: './stp-tab.component.html',
  styleUrls: ['./stp-tab.component.scss'],
})
export class StpTabComponent implements OnInit {
  selectedIndex = 0;
  stpMainInfo$: Subscription;
  stpMainInfo: any;
  userId: number;

  constructor(
    private stpRegistrationService: StpRegistrationService,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.userId = this.route.snapshot.params.userId;

    if(this.userId){
      this.checkCompleteAdmin();
    }else{
      let currentUserInfo: LoginResponse = JSON.parse(localStorage.getItem('currentUserInfo') ?? '{}');

      if(currentUserInfo?.id != null){
        this.checkComplete(currentUserInfo.id);
      };
    }


    this.stpMainInfo$ = this.stpRegistrationService.getStpMainInfo().subscribe(
      (res) => {
        this.stpMainInfo = res;
      }
    );
  }

  checkComplete(userId: number): void {
    this.stpRegistrationStorageService.getlUserInfoById(userId).subscribe((rs) => {
      if (rs.success) {
        let data = rs.data;
        let isCompleted: string = '';

        if (data.stpUserStatus) {
          isCompleted = data.stpUserStatus.status;
          if (isCompleted == 'Completed') {
            this.stpRegistrationService.setCheckIsCompleteRegistration(true);
            this.router.navigate(['/home/stp-registration/stp-application-view/' + data.stpMain.id]);
          }
        }
      }
    });
  }

  checkCompleteAdmin(): void {
    this.stpRegistrationStorageService.getlUserInfoById(this.userId).subscribe((rs) => {
      if (rs.success) {
        let data = rs.data;
        let isCompleted: string = '';

        if (data.stpUserStatus) {
          isCompleted = data.stpUserStatus.status;
        }
      }
    });
  }

  onclickButton() {
    this.selectedIndex = (this.selectedIndex + 1) % 8;
  }

  onclickButtonPrevious() {
    this.selectedIndex = this.selectedIndex - 1;
    if (this.selectedIndex < 0) {
      this.selectedIndex = 8;
    }
  }

  ngOnDestroy(): void {
    this.stpMainInfo$.unsubscribe();
  }
}
